export default function SearchStrategyIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0789 2.13274C13.2229 1.74363 13.7732 1.74363 13.9172 2.13274L14.1505 2.76324C14.4221 3.49723 15.0008 4.07594 15.7348 4.34754L16.3653 4.58085C16.7544 4.72483 16.7544 5.27517 16.3653 5.41915L15.7348 5.65246C15.0008 5.92406 14.4221 6.50277 14.1505 7.23676L13.9172 7.86726C13.7732 8.25637 13.2229 8.25637 13.0789 7.86726L12.8456 7.23676C12.574 6.50277 11.9953 5.92406 11.2613 5.65246L10.6308 5.41915C10.2417 5.27517 10.2417 4.72483 10.6308 4.58085L11.2613 4.34754C11.9953 4.07594 12.574 3.49723 12.8456 2.76324L13.0789 2.13274Z"
        fill="#7F56D9"
      />
      <path
        d="M9.16309 1.66699C9.92872 1.66699 10.6675 1.78189 11.3633 1.99512C10.9222 2.55152 10.3732 3.0163 9.74609 3.36133C9.55435 3.3423 9.35983 3.33301 9.16309 3.33301C5.94155 3.33301 3.33008 5.94448 3.33008 9.16602C3.33008 12.3876 5.94155 14.999 9.16309 14.999C12.3846 14.999 14.9961 12.3876 14.9961 9.16602C14.9961 9.11866 14.9933 9.0715 14.9922 9.02441C15.3281 8.32049 15.8105 7.70319 16.4023 7.21094C16.5703 7.83442 16.6621 8.48946 16.6621 9.16602C16.6621 10.9312 16.0498 12.552 15.0293 13.833L18.0869 16.9121C18.4107 17.2386 18.4084 17.7658 18.082 18.0898C17.7556 18.4136 17.2283 18.4113 16.9043 18.085L13.8545 15.0127C12.5697 16.045 10.9395 16.665 9.16309 16.665C5.02154 16.665 1.66406 13.3076 1.66406 9.16602C1.66406 5.02447 5.02154 1.66699 9.16309 1.66699Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
